import React, { useMemo } from 'react';

import { AdsContext } from '@/core/lib/ads/ads.context';

const OptiDigital: React.FC<React.PropsWithChildren> = ({ children }) => {
  const value = useMemo(
    () => ({
      Ad: () => null,
      isLoaded: true,
      Interstitial: () => null,
      showReward: () => {},
    }),
    [],
  );

  return <AdsContext.Provider value={value}>{children}</AdsContext.Provider>;
};

export default OptiDigital;
